import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useModal } from 'react-modal-hook'
import { Formik, Form, Field } from 'formik'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import Loading from 'custom/assets/loaders/Loading'
import DepositeService from '../../services/deposite.service'
import Modal from '../../components/Modal/Modal'
import { CreateTermDepositSchema } from '../../schemas/deposit'
import InputError from '../../components/InputError/InputError'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import { useHistory } from 'react-router-dom'
import NumberFormat from 'react-number-format'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import PortfolioService from '../../services/portfolio.service'
import TermsAndConditions from '../../components/TermsAndConditions/TermsAndCondition'
import { getFeatureListSelector } from '../../selectors/app.selector'
import validationConfig from 'custom/config/validation.config.json'
const depositConfig = validationConfig['deposit']
import {
  BUTTON_KEYS,
  CREATE_TERM_DEPOSIT_KEYS,
  VALIDATION_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import config from 'custom/config/environment'

export default function CreateTermDeposits() {
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [isLoading, setisLoading] = useState(false)
  const [autoRen, setAutoRen] = useState(false)
  const [otp, setOtp] = useState('')
  const [formValues, setFormValues] = useState({})
  const [formDatas, setFormDatas] = useState([])
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const history = useHistory()
  const [tenorLists, setTenorLists] = useState([])
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [randomEnabled, setRandomEnabled] = useState('')
  const [accounts, setAccounts] = useState([])
  const [interestRateList, setInterestRateList] = useState([])
  const [currencyList, setCurrencyList] = useState(['INR'])
  const [productList, setProductList] = useState([])
  const [isVerified, setIsVerified] = useState(false)
  const [selected, setSelected] = useState('')
  const [selectedTenor, setSelectedTenor] = useState('')
  const [verifyDetails, setVerifyDetails] = useState({})
  const featureList = useSelector(getFeatureListSelector)
  const [accountClass, setAccountClass] = useState('')
  const [interestRate, setInterestRate] = useState('')
  const [requestValues, setRequestValues] = useState({})
  const { t } = useTranslation()

  const paymentOptions = {
    R: t(CREATE_TERM_DEPOSIT_KEYS.CREDIT_INTEREST_ON_MATURITY),
    M: t(CREATE_TERM_DEPOSIT_KEYS.CREDIT_INTEREST_MONTHLY),
    Q: t(CREATE_TERM_DEPOSIT_KEYS.CREDIT_INTEREST_QUARTERLY),
  }

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{error?.code}</b> : {error?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  // const changeSelectOptionHandler = (event) => {
  //   setSelected(event.target.value)
  // }

  // const changeSelectTenorOptionHandler = (event) => {
  //   setSelectedTenor(event.target.value)
  // }

  // const getIntrestRate = (event, values) => {
  //   var x = interestRateList
  //     .filter((e) => e.currency == values.toCurrency)
  //     .filter((e) => e.tenorDays == event.target.value)
  //     .filter((e) => e.prodDesc == values.interestCredit)
  //   setIsVerified(true)
  //   setAccountClass(x[0].product)
  //   setInterestRate(x[0].rateOfInterest)
  // }

  // const fetchInterestList = useCallback(
  //   async (toCurrency, interestCredit = '', tenorPeriod = '', data) => {
  //     try {
  //       setisLoading(true)
  //       setIsVerified(false)
  //       const response = await DepositeService.getTenorLists({
  //         currency: toCurrency,
  //         product: interestCredit,
  //         tenorDays: tenorPeriod,
  //         ...data,
  //       })
  //       if (response.status === 200) {
  //         setisLoading(false)
  //         setInterestRateList(response.data['tdInterestRatesList'])
  //         setIsVerified(true)
  //       }
  //       setFormDatas(interestRateList)
  //     } catch (err) {
  //       setLoading(false)
  //       showModal(err)
  //     }
  //   },
  //   [interestRateList],
  // )

  // const productDuplicate = () => {
  //   let setObj = new Set()
  //   let result = interestRateList.reduce((acc, item) => {
  //     if (!setObj.has(item.product)) {
  //       setObj.add(item.product, item)
  //       acc.push(item)
  //     }
  //     return acc
  //   }, [])
  //   let counter = 0
  //   result.forEach((item) => {
  //     if (Object.values(item).indexOf('USD') >= 0) {
  //       counter++
  //     }
  //   })
  //   if (counter === 0) {
  //     result.push(interestRateList[interestRateList.length - 1])
  //   }
  //   setProductList(result)
  // }

  const fetchAccounts = useCallback(async () => {
    const response = await PortfolioService.getAccountDetails({
      accountType: 'S',
    })
    if (response.status === 200) {
      setLoading(false)
      setAccounts(response.data['accountSummaryDetails'])
      setStage(1)
    }
  }, [])

  useEffect(() => {
    fetchAccounts()
    // fetchInterestList()
  }, [])

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const response = await DepositeService.confirmTermDeposit({
        ...requestValues,
        otp: otp || '0000',
        product: verifyDetails['product'],
      })
      if (response.status === 200) {
        setMessage(response.data['message'])
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setError(err)
    }
  }, [
    formValues,
    autoRen,
    otp,
    formDatas,
    randomEnabled,
    tenorLists,
    accountClass,
    interestRate,
    verifyDetails,
    requestValues,
  ])

  const onVerify = useCallback(
    async (data, { setSubmitting }) => {
      try {
        // const accountDetails = accounts.filter(
        //   (value) => value?.ACCOUNT_NO === data.accountNumber,
        // )[0]
        // const featureDetails = featureList['TD_CREATE']
        // if (featureDetails[accountDetails['ACC_TYPE']] === 'N') {
        //   setError({
        //     code: 'Access Denied',
        //     message:
        //       "You don't have permission with selected source Account. Try with different account.",
        //   })
        //   showModal()
        //   return
        // }

        const creditAccountDetails = accounts.filter(
          (value) => value?.accountNo === data.creditAccNo,
        )[0]

        const debitAccountDetails = accounts.filter(
          (value) => value?.accountNo === data.debitAccNo,
        )[0]

        if (data.debitAccNo === data.creditAccNo) {
          setError({
            code: 'Error',
            message: 'Credit and Debit Account should not be same',
          })
          showModal()
          return
        }

        if (data.amount === '0.00' || data.amount === '.00') {
          return
        }
        setSubmitting(true)
        setFormValues({
          ...data,
          creditAccNo: creditAccountDetails,
          debitAccNo: debitAccountDetails,
        })
        debugger
        let reqParam = {
          currency: data.toCurrency,
          interestCredit: data.interestCredit,
          branchCode: debitAccountDetails.brnCode,
          product: 'SA01',
          payInAmt: +data.amount,
          months: data.tenorPeriod === 'Months' ? data.tenorValue : '0',
          years: data.tenorPeriod === 'Years' ? data.tenorValue : '0',
          days: data.tenorPeriod === 'Days' ? data.tenorValue : '0',
          creditAccNo: creditAccountDetails.accountNo,
          creditAccBrn: creditAccountDetails.brnCode,
          debitAccNo: debitAccountDetails.accountNo,
          debitAccBrn: debitAccountDetails.brnCode,
          autoRenewal: autoRen ? 'AUTO_RENEWAL' : 'CLOSE_ON_MATURITY',
          principle: data.principleType === 'principle',
          cdf: {
            customerName: debitAccountDetails.customerName,
            customerNo: debitAccountDetails.custNo,
          },
        }

        const response = await DepositeService.createTermDeposit(reqParam)
        if (response.status === 200) {
          setLoading(false)
          setStage(2)
          setOtpEnabled(response.data['otpEnable'])
          setRandomEnabled(response.data['randomKey'])
          setVerifyDetails(response.data)
          setRequestValues(reqParam)
        }
      } catch (err) {
        setLoading(false)
        setError(err)
      }
    },
    [
      formValues,
      accounts,
      autoRen,
      tenorLists,
      featureList,
      interestRateList,
      accountClass,
      interestRate,
      otpEnabled,
    ],
  )

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return <NeoSuccess message={message} linkPath='/deposit-view' />
      default:
        return renderForm()
    }
  }

  function renderForm() {
    if (loading) {
      return (
        <div className='justify-content-center d-flex align-items-center'>
          <Loading width='50px' height='50px' />
        </div>
      )
    }
    return (
      <div>
        <div className='heading-style'>{t(CREATE_TERM_DEPOSIT_KEYS.TITLE)}</div>
        <Formik
          initialValues={{
            creditAccNo: '',
            debitAccNo: '',
            toCurrency: '',
            interestCredit: '',
            amount: '',
            tenorPeriod: '',
            tenorValue: '',
            depositType: config.TD_CLOSE_INSTRUCTION ? 'closeOnMaturity' : '',
            principleType: config.TD_CLOSE_INSTRUCTION ? 'principle' : '',
          }}
          validationSchema={CreateTermDepositSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, handleChange, setFieldValue, values, disabled }) => (
            <Form>
              <div className='form-group my-4'>
                {config.TD_CLOSE_INSTRUCTION && (
                  <div className='d-flex justify-content-center align-items-center'>
                    <div className='custom-control custom-radio custom-control-inline'>
                      <Field
                        as='input'
                        type='radio'
                        id='closeOnMaturity'
                        name='depositType'
                        value='closeOnMaturity'
                        className='custom-control-input'
                        onClick={() => setAutoRen(false)}
                      />
                      <label className='custom-control-label' htmlFor='closeOnMaturity'>
                        {t(CREATE_TERM_DEPOSIT_KEYS.CLOSE_ON_MATURITY)}
                      </label>
                    </div>
                    <div className='custom-control custom-radio custom-control-inline'>
                      <Field
                        as='input'
                        value='autoRenewal'
                        type='radio'
                        id='autoRenewal'
                        name='depositType'
                        className='custom-control-input'
                        onClick={() => setAutoRen(true)}
                      />
                      <label className='custom-control-label' htmlFor='autoRenewal'>
                        {t(CREATE_TERM_DEPOSIT_KEYS.AUTO_RENEWAL)}
                      </label>
                    </div>
                  </div>
                )}
                {autoRen ? (
                  <div className='mt-3 d-flex justify-content-center align-items-center'>
                    <div className='custom-control custom-radio custom-control-inline new-style-radio'>
                      <Field
                        as='input'
                        type='radio'
                        id='principle'
                        name='principleType'
                        value='principle'
                        className='custom-control-input'
                      />
                      <label className='custom-control-label' htmlFor='principle'>
                        {t(CREATE_TERM_DEPOSIT_KEYS.ROLL_OVER_PRINCIPLE)}
                      </label>
                    </div>
                    <div className='custom-control custom-radio custom-control-inline new-style-radio'>
                      <Field
                        as='input'
                        value='principleInterest'
                        type='radio'
                        id='principleInterest'
                        name='principleType'
                        className='custom-control-input'
                      />
                      <label className='custom-control-label' htmlFor='principleInterest'>
                        {t(CREATE_TERM_DEPOSIT_KEYS.ROLL_OVER_PRINCIPLE_INTEREST)}
                      </label>
                    </div>
                  </div>
                ) : (
                  <div />
                )}
                <div className='d-flex row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='1'
                      showAsterisk={depositConfig['isAccountNoRequired']}
                      text={t(CREATE_TERM_DEPOSIT_KEYS.CREDIT_ACCOUNT)}
                      name='creditAccNo'
                      mode='select'
                      list={accounts}
                      keyValue='accountNo'
                      onChange={handleChange}
                    />
                    <InputError text={errors.creditAccNo} touched={touched.creditAccNo} />
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='2'
                      showAsterisk={depositConfig['isAccountNoRequired']}
                      text={t(CREATE_TERM_DEPOSIT_KEYS.DEBIT_ACC_NO)}
                      name='debitAccNo'
                      mode='select'
                      list={accounts}
                      keyValue='accountNo'
                      onChange={handleChange}
                    />
                    <InputError text={errors.debitAccNo} touched={touched.debitAccNo} />
                  </div>
                  <div className='form-group  col-12'>
                    <NeoInput
                      tabIndex='3'
                      showAsterisk={depositConfig['isCurrencyRequired']}
                      text={t(CREATE_TERM_DEPOSIT_KEYS.CURRENCY)}
                      name='toCurrency'
                      keyValue={null}
                      list={currencyList}
                      mode='select'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                    />
                    <InputError text={errors.toCurrency} touched={touched.toCurrency} />
                  </div>

                  {/* {selected !== '' ? (
                    <div className='form-group col-12'>
                      <NeoInput
                        showAsterisk={depositConfig['isInterestCreditRequired']}
                        text={t(CREATE_TERM_DEPOSIT_KEYS.PRODUCT)}
                        name='interestCredit'
                        mode='select'
                        list={productList.filter(
                          (element) => values.toCurrency === element.currency,
                        )}
                        keyValue='prodDesc'
                        value={values.interestCredit}
                        onChange={(e) => {
                          handleChange(e)
                          changeSelectTenorOptionHandler(e)
                          setFieldValue('tenorPeriod', '')
                          setIsVerified(false)
                        }}
                        onClick={productDuplicate}
                      />
                      <InputError text={errors.interestCredit} touched={touched.interestCredit} />
                    </div>
                  ) : (
                    <div className='form-group col-12'>
                      <NeoInput
                        showAsterisk={depositConfig['isInterestCreditRequired']}
                        text={t(CREATE_TERM_DEPOSIT_KEYS.PRODUCT)}
                        name='interestCredit'
                        mode='select'
                        list={productList}
                        keyValue='prodDesc'
                        value={values.interestCredit}
                        onChange={handleChange}
                        disabled={!disabled}
                      />
                      <InputError text={errors.interestCredit} touched={touched.interestCredit} />
                    </div>
                  )} */}

                  <div className='form-group col-12'>
                    <label className='control-label'>
                      {t(CREATE_TERM_DEPOSIT_KEYS.PAYMENT_METHOD)}{' '}
                    </label>
                    <Field
                      tabIndex={'4'}
                      as='select'
                      name='interestCredit'
                      className='form-control'
                      onChange={handleChange}>
                      <option value='' />
                      {config.TD_PAYMENT_METHOD.map((option, index) => (
                        <option value={option} key={index}>
                          {paymentOptions[option]}
                        </option>
                      ))}
                    </Field>
                    <InputError text={errors.interestCredit} touched={touched.interestCredit} />
                  </div>

                  {/* {selectedTenor !== '' ? (
                    <div className='form-group col-12'>
                      <NeoInput
                        showAsterisk={depositConfig['isTenureRequired']}
                        text={t(CREATE_TERM_DEPOSIT_KEYS.TENURE)}
                        name='tenorPeriod'
                        mode='select'
                        list={interestRateList.filter(
                          (element) =>
                            element.currency === values.toCurrency &&
                            element.prodDesc === values.interestCredit,
                        )}
                        keyValue='tenorDays'
                        value={values.tenorPeriod}
                        onChange={(e) => {
                          handleChange(e)
                          getIntrestRate(e, values)
                        }}
                      />
                      <InputError text={errors.tenorPeriod} touched={touched.tenorPeriod} />
                    </div>
                  ) : (
                    <div className='form-group col-12'>
                      {' '}
                      <NeoInput
                        showAsterisk={depositConfig['isTenureRequired']}
                        text={t(CREATE_TERM_DEPOSIT_KEYS.TENURE)}
                        name='tenorPeriod'
                        mode='select'
                        list={interestRateList}
                        keyValue='tenorDays'
                        value={values.tenorPeriod}
                        onChange={(e) => {
                          handleChange(e)
                          getIntrestRate(e, values)
                        }}
                      />
                      <InputError text={errors.tenorPeriod} touched={touched.tenorPeriod} />
                    </div>
                  )} */}
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      showAsterisk={depositConfig['isTenureRequired']}
                      text={t(CREATE_TERM_DEPOSIT_KEYS.TENURE)}
                      name='tenorPeriod'
                      mode='select'
                      list={[
                        t(CREATE_TERM_DEPOSIT_KEYS.DAYS),
                        t(CREATE_TERM_DEPOSIT_KEYS.MONTHS),
                        t(CREATE_TERM_DEPOSIT_KEYS.YEARS),
                      ]}
                      keyValue={null}
                      onChange={(e) => {
                        handleChange(e)
                        setFieldValue('tenorValue', '')
                      }}
                    />
                    <InputError text={errors.tenorPeriod} touched={touched.tenorPeriod} />
                  </div>
                  {/* {isLoading ? (
                    <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
                      <Loading width='30px' height='30px' />
                    </div>
                  ) : (
                    isVerified &&
                    interestRate > 0 && (
                      <div className='form-group col-12'>{t(CREATE_TERM_DEPOSIT_KEYS.INTEREST_RATE)} : &nbsp; {interestRate}</div>
                    )
                  )} */}
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='6'
                      showAsterisk={depositConfig['isTenureValueRequired']}
                      mode='onlyNumber'
                      text={t(CREATE_TERM_DEPOSIT_KEYS.TENURE_VALUE)}
                      onChange={(values) => {
                        setFieldValue('tenorValue', values.value)
                      }}
                      name='tenorValue'
                    />
                    <InputError text={errors.tenorValue} touched={touched.tenorValue} />
                  </div>
                </div>
                <div className='d-flex row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='7'
                      showAsterisk={depositConfig['isAmountRequired']}
                      mode='amount'
                      text={t(CREATE_TERM_DEPOSIT_KEYS.AMOUNT)}
                      onChange={(values) => {
                        setFieldValue('amount', values.value)
                      }}
                      name='depositAmount'
                    />
                    <InputError text={errors.amount} touched={touched.amount} />
                    <InputError
                      text={t(VALIDATION_KEYS.TRANSFER_AMOUNT_VALIDATION)}
                      touched={values.amount === '0.00' || values.amount === '.00'}
                    />
                  </div>
                </div>
                <div className='d-flex row'></div>
                <div className='mt-3'>
                  {isSubmitting ? (
                    renderLoading()
                  ) : (
                    <NeoButton
                      tabIndex='8'
                      type='submit'
                      mode='newDesign'
                      disabled={isSubmitting}
                      text={t(BUTTON_KEYS.CREATE)}
                    />
                  )}
                </div>

                <div className='back-cancel-btn-container'>
                  <button
                    tabIndex={'9'}
                    className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                    onClick={() => history.goBack()}>
                    {t(BUTTON_KEYS.CANCEL)}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(CREATE_TERM_DEPOSIT_KEYS.CONFIRM_TITLE)}</h3>
        {config.TD_CLOSE_INSTRUCTION && (
          <>
            {!autoRen ? (
              <div>
                <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.DEPOSIT_TYPE)}</h6>
                <h6 className='value'>{t(CREATE_TERM_DEPOSIT_KEYS.CLOSE_ON_MATURITY)}</h6>
              </div>
            ) : (
              <div>
                <div>
                  <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.DEPOSIT_TYPE)}</h6>
                  <h6 className='value'>{t(CREATE_TERM_DEPOSIT_KEYS.AUTO_RENEWAL)}</h6>
                </div>
                <div>
                  <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.PRINCIPLE)}</h6>
                  <h6 className='value'>
                    {formValues.principleType === 'principle'
                      ? t(CREATE_TERM_DEPOSIT_KEYS.ROLL_OVER_PRINCIPLE)
                      : t(CREATE_TERM_DEPOSIT_KEYS.ROLL_OVER_PRINCIPLE_INTEREST)}
                  </h6>
                </div>
              </div>
            )}
          </>
        )}
        <div>
          <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.CREDIT_ACCOUNT)}</h6>
          <h6 className='value'>{formValues.creditAccNo.accountNo}</h6>
        </div>
        <div>
          <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.DEBIT_ACC_NO)}</h6>
          <h6 className='value'>{formValues.debitAccNo.accountNo}</h6>
        </div>

        <div>
          <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.CURRENCY)}</h6>
          <h6 className='value'>{formValues.toCurrency}</h6>
        </div>
        <div>
          <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.PAYMENT_METHOD)}</h6>
          <h6 className='value'>{paymentOptions[formValues.interestCredit]}</h6>
        </div>
        {/* <div>
          <h6 className='label'>Product Description</h6>
          <h6 className='value'>{formDatas.prodDesc}</h6>
        </div>
        <div>
          <h6 className='label'>Product Type</h6>
          <h6 className='value'>{formDatas.prodType}</h6>
        </div> */}
        <div>
          <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.AMOUNT)}</h6>
          <h6 className='value'>
            <NumberFormat
              value={formValues.amount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>

        <div>
          <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.TENURE)} </h6>
          <h6 className='value'>
            {formValues.tenorValue} {formValues.tenorPeriod}
          </h6>
        </div>

        <div>
          <h6 className='label'>{t(CREATE_TERM_DEPOSIT_KEYS.INTEREST_RATE)}</h6>
          <h6 className='value'>{interestRate || '0'}</h6>
        </div>

        <div>
          <TermsAndConditions module='TERM_DEPOSITE' />
        </div>

        <div className='mt-3'>
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              mode={'newDesign'}
              type='button'
              text={t(BUTTON_KEYS.CONFIRM)}
              onClick={() => (otpEnabled === true ? setStage(3) : onConfirm())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(BUTTON_KEYS.BACK)}
        </div>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey={'TERM_DEPOSIT'}
      showEmptySpace={true}
      keyPath={'DEPOSIT'}>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithOutAccountCard>
  )
}
